export default {
  auth: '/api/auth/swagger.json',
  'core-service': '/core-service/swagger/v1/swagger.json',
  dashboards: '/api/dashboards/swagger.json',
  files: '/api/files/swagger.json',
  forms: '/api/forms/swagger.json',
  groups: '/api/user/swagger.json',
  instance: '/api/instance/swagger.json',
  processes: '/api/processes/swagger.json',
  reports: '/api/reports/swagger.json',
  schedulers: '/api/schedulers/swagger.json',
  settings: '/api/settings/swagger.json',
  taskDispatcher: '/api/task-dispatcher/swagger.json',
  tenant: '/api/tenant/swagger.json',
  user: '/api/user/swagger.json',
  integrations: '/api/integrations/swagger.json'
}
